export enum LanguageEnum {
  GB = 'GB',
  FR = 'FR'
}
